import React, {useContext} from 'react';

import { languageOptions} from '../../services/Language';
import {LanguageContext} from '../../containers/Language/LanguageProvider';
export function LanguageSelector() {
    let {language, onLanguageChange} = useContext(LanguageContext);
    const handleLanguageChange = (event) => {
        const selectedLanguage = languageOptions.find(item=> item.id === event.target.value);
        onLanguageChange(selectedLanguage);
    }

    return (
        <select style={{height: "2.5vw"}}
            onChange={handleLanguageChange}
            value={language.id}
         >
             {
                 languageOptions.map(item=> (
                    <option
                        key={item.id}
                        value={item.id}
                    >
                    {item.text}
                    </option>
                 ))
             }
         </select>
    );
}